import React from 'react';

import {
  Container,
  Button,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField, OrangeCard } from '../../../components';

import './style.scss';

const ParagraphCtaLandingpage = ({ id, entity, wide }) => {

  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const body = entity.getIn(['field_body', 0, 'value']);
  const quote = entity.getIn(['field_quote', 0, 'value']);
  const author = entity.getIn(['field_author', 0, 'value']);
  const image = entity.getIn(['field_media_item', 0, 'styles', 'paragraph_cta_landing_page']);

  return (
    <Container id={id} className="Paragraph ParagraphCtaLandingpage">
      <div className="row">
        <div className="col-12">
          <h1 className="ParagraphCtaLandingpage__title">{title}</h1>
          <p className="ParagraphCtaLandingpage__body">
            <WysiwygField
              property="schema:text"
              html={body}
            />
          </p>
        </div>
        <div className={`ParagraphCtaLandingpage__image ${wide ? 'col-10 offset-2 col-sm-11 offset-sm-1' : 'col-11 offset-2 col-lg-8 col-md-10 offset-lg-3'}`}>
          <Image
            src={image}
            className="ParagraphImage__image"
          />
        </div>
        <div className={`ParagraphCtaLandingpage__card ${wide ? 'col-10 col-sm-11' : 'col-11 col-lg-7 col-md-8 offset-lg-1'}`}>
          <OrangeCard className="ParagraphCtaLandingpage__cardwrapper">
            {title && (
              <h3 className="ParagraphCtaLandingpage__cardtitle">{quote}</h3>
            )}
            <WysiwygField
              property="schema:text"
              className="ParagraphCtaLandingpage__cardbody"
              html={author}
            />
            {link && linkTitle && (
              <Button href={link}>{linkTitle}</Button>
            )}
          </OrangeCard>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphCtaLandingpage;
